import { schema } from "normalizr";

const markeSchema = new schema.Entity("marke", {}, { idAttribute: "id" });

export { markeSchema };
